module.exports = "<div class=\"bg-white padder-md\">\n  <div class=\"grid-noBottom\">\n    <div class=\"col align-tb space-between\" ng-transclude>\n\n    </div>\n    <!-- .col END -->\n\n    <div class=\"col-right align-tb header-logo-wrap\">\n      <img src=\"{{$ctrl.logoSrc}}\" class=\"main-header-logo\" alt=\"{{$ctrl.logoAlt}}\">\n    </div>\n    <!-- .col END -->\n  </div>\n  <!-- .grid END -->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpMainHeader/adpMainHeader.html
// module id = 507
// module chunks = 0